import api from './client'

// Fotos de producto desde el celular con IA (/m/fotos, Martin 2 oct 2026).
export const fotosIaApi = {
  estado: () => api.get('/fotos-ia/estado'),
  articulos: (ean) => api.get('/fotos-ia/articulos', { params: { ean } }),
  articulosPorSku: (sku) => api.get('/fotos-ia/articulos', { params: { sku } }),
  procesar: (articuloId, archivo) => {
    const fd = new FormData()
    fd.append('articulo_id', articuloId)
    fd.append('foto', archivo)
    return api.post('/fotos-ia', fd, { timeout: 180000 })
  },
  // Lo que está mal, en palabras del operario: Gemini rehace la foto con la
  // original como referencia (3 oct 2026). Devuelve la foto NUEVA.
  corregir: (id, correccion) => api.post(`/fotos-ia/${id}/corregir`, { correccion }, { timeout: 180000 }),
  // La imagen va con el token (no es pública): se baja como blob.
  imagen: (id, original = false) => api.get(`/fotos-ia/${id}/imagen`, { params: original ? { original: 1 } : {}, responseType: 'blob' }),
  publicar: (id, destino = 'principal') => api.post(`/fotos-ia/${id}/publicar`, { destino }),
  descartar: (id) => api.post(`/fotos-ia/${id}/descartar`),
}
